import { render, staticRenderFns } from "./ArtificialPaperList.vue?vue&type=template&id=30ae2c7c&scoped=true"
import script from "./ArtificialPaperList.vue?vue&type=script&lang=js"
export * from "./ArtificialPaperList.vue?vue&type=script&lang=js"
import style0 from "./ArtificialPaperList.vue?vue&type=style&index=0&id=30ae2c7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ae2c7c",
  null
  
)

export default component.exports